"use strict";
var Shuffle = window.Shuffle;
var elementExist = document.querySelector(".js-shuffle");

if (elementExist) {
  var Demo = function(element) {
    this.shapes = Array.from(document.querySelectorAll(".js-shapes input")); //array of all shape filters checkboxes
    this.colors = Array.from(document.querySelectorAll(".js-colors button")); //array of all color filters buttons

    // this.shuffle = new Shuffle(element, {
    //     easing: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)', // easeOutQuart
    //     sizer: '.the-sizer'
    // });

    this.filters = {
      shapes: [], //shapaes = [circle, diamond, square,triangle]
      colors: [] //colors = [green, blue, red, orange]
    };

    this._bindEventListeners();

    this.element = document.getElementById("grid");
    this.gridItems = this.element.querySelectorAll(".shape");
    var sizer = this.element.querySelector(".my-sizer-element");

    this.shuffle = new Shuffle(this.element, {
      itemSelector: ".picture-item",
      easing: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
      sizer: sizer
    });

    var callback = this.showItemsInViewport.bind(this);
    this.observer = new window.IntersectionObserver(callback, {
      threshold: 0.5
    });

    // Loop through each grid item and add it to the viewport watcher.
    for (var i = 0; i < this.gridItems.length; i++) {
      this.observer.observe(this.gridItems[i]);
    }

    // Add the transition class to the items after ones that are in the viewport
    // have received the `in` class.
    setTimeout(
      function() {
        this.addTransitionToItems();
      }.bind(this),
      100
    );

    this.addShuffleEventListeners();
  };

  /**
   * Bind event listeners for when the filters change.
   */
  Demo.prototype._bindEventListeners = function() {
    this._onShapeChange = this._handleShapeChange.bind(this);
    this._onColorChange = this._handleColorChange.bind(this);

    this.shapes.forEach(function(input) {
      input.addEventListener("change", this._onShapeChange);
    }, this);

    this.colors.forEach(function(button) {
      button.addEventListener("click", this._onColorChange);
    }, this);
  };

  /**
   * Get the values of each checked input.
   * @return {Array.<string>}
   */
  Demo.prototype._getCurrentShapeFilters = function() {
    return this.shapes
      .filter(function(input) {
        return input.checked;
      })
      .map(function(input) {
        return input.value;
      });
  };

  /**
   * Get the values of each `active` button.
   * @return {Array.<string>}
   */
  Demo.prototype._getCurrentColorFilters = function() {
    return this.colors
      .filter(function(button) {
        return button.classList.contains("active");
      })
      .map(function(button) {
        return button.getAttribute("data-value");
      });
  };

  /**
   * A shape input check state changed, update the current filters and filte.r
   */
  Demo.prototype._handleShapeChange = function() {
    this.filters.shapes = this._getCurrentShapeFilters();
    this.filter();
  };

  /**
   * A color button was clicked. Update filters and display.
   * @param {Event} evt Click event object.
   */
  Demo.prototype._handleColorChange = function(evt) {
    var button = evt.currentTarget;

    // Treat these buttons like radio buttons where only 1 can be selected.
    if (button.classList.contains("active")) {
      button.classList.remove("active");
    } else {
      this.colors.forEach(function(btn) {
        btn.classList.remove("active");
      });

      button.classList.add("active");
    }

    this.filters.colors = this._getCurrentColorFilters();
    this.filter();
  };

  /**
   * Filter shuffle based on the current state of filters.
   */
  Demo.prototype.filter = function() {
    if (this.hasActiveFilters()) {
      this.shuffle.filter(this.itemPassesFilters.bind(this));
    } else {
      this.shuffle.filter(Shuffle.ALL_ITEMS);
    }
  };

  /**
   * If any of the arrays in the `filters` property have a length of more than zero,
   * that means there is an active filter.
   * @return {boolean}
   */
  Demo.prototype.hasActiveFilters = function() {
    return Object.keys(this.filters).some(function(key) {
      return this.filters[key].length > 0;
    }, this);
  };

  /**
   * Determine whether an element passes the current filters.
   * @param {Element} element Element to test.
   * @return {boolean} Whether it satisfies all current filters.
   */
  Demo.prototype.itemPassesFilters = function(element) {
    var shapes = this.filters.shapes;
    var colors = this.filters.colors;
    var shape = element.getAttribute("data-tag");
    var color = element.getAttribute("data-category");
    // var color = element.getAttribute('data-color').split(' ');
    // console.log(color);

    // var chk = [];
    // for (var i=0; i < color.length; i++) {
    //     if (!colors.includes(color[i])){
    //         chk.push(0);
    //     }
    // }

    // console.log(chk.includes(0));

    // If there are active shape filters and this shape is not in that array.
    if (shapes.length > 0 && !shapes.includes(shape)) {
      return false;
    }

    // If there are active color filters and this color is not in that array.
    if (colors.length > 0 && !colors.includes(color)) {
      return false;
    }

    return true;
  };

  Demo.prototype.addShuffleEventListeners = function() {
    this.shuffle.on(Shuffle.EventType.LAYOUT, function(data) {
      console.log("layout. data:", data);
    });

    this.shuffle.on(Shuffle.EventType.REMOVED, function(data) {
      console.log("removed. data:", data);
    });
  };

  /**
   * Add the `in` class to the element after it comes into view.
   */
  Demo.prototype.showItemsInViewport = function(changes) {
    changes.forEach(function(change) {
      if (change.isIntersecting) {
        change.target.classList.add("in");
      }
    });
  };

  /**
   * Only the items out of the viewport should transition. This way, the first
   * visible ones will snap into place.
   */
  Demo.prototype.addTransitionToItems = function() {
    for (var i = 0; i < this.gridItems.length; i++) {
      var inner = this.gridItems[i].querySelector(".picture-item__inner");
      inner.classList.add("picture-item__inner--transition");
    }
  };

  // Sorting

  Demo.prototype.addSorting = function() {
    document.querySelector(".sort-options").addEventListener("change", this._handleSortChange.bind(this));
  };

  Demo.prototype._handleSortChange = function(evt) {
    var value = evt.target.value;

    function sortByDate(element) {
      return element.getAttribute("data-created");
    }

    function sortByTitle(element) {
      return element.getAttribute("data-title").toLowerCase();
    }

    var options;
    if (value === "date-created") {
      options = {
        reverse: true,
        by: sortByDate
      };
    } else if (value === "title") {
      options = {
        by: sortByTitle
      };
    } else {
      options = {};
    }

    this.shuffle.sort(options);
  };

  document.addEventListener("DOMContentLoaded", function() {
    window.demo = new Demo(document.querySelector(".js-shuffle"));
  });
}
